import StatusTag from './StatusTag';
import moment from 'moment';

function InfoCard({ number, title, date, comment, user, priority, status }) {
  return (
    <div className="info-card">
      <h2 className="title">
        #{number} - {title}
      </h2>
      <div className="meta-info">
        <span className="label">Datum:</span>
        <span className="date">{moment(date).format('MMM DD, YYYY')}</span>
        <span className="label">Korisnik:</span>
        <span className="user">{user}</span>
        <span className="label">Prioritet:</span>
        <span className={`priority priority-${priority.toLowerCase()}`}>
          {priority}
        </span>
        <span className="label" style={{ marginLeft: '10px' }}>
          Status:
        </span>
        <StatusTag status={status} />
      </div>
      <p className="label">Opis:</p>
      <p className="comment">{comment}</p>
    </div>
  );
}

export default InfoCard;
